import DyteClient from "@dytesdk/web-core";
import {useLanguage, defaultLanguage} from '@dytesdk/ui-kit';
import {customTranslations} from '@/translations/dyteTranslations';

export const createDyteInstanceMeeting = async (token, configurations = {}) => {

    const meeting = await DyteClient.init({
        authToken: token,
        modules: {
            pip: false,
        },
        ...configurations
    });
    return meeting;
}

export const setDyteInstanceMeeting = (meeting, items) => {

    const myLanguagePack = useLanguage({
        ...defaultLanguage,
        ...customTranslations
    });
    for (const el of items) {
        el.meeting = meeting;
        el.t = myLanguagePack;
    }
}

export const setMeetingEvents = (meeting, events, participantsEvents) => {
    events.forEach(event => {
        const [name, fn] = event;
        meeting.self.on(name, fn);
    })

    participantsEvents.forEach(event => {
        const [name, fn] = event;
        meeting.participants.joined.on(name, fn);
    })
}

export const eventsConstants = {
    ROOM_JOINED: "roomJoined",
    ROOM_LEFT: "roomLeft"
}
